export default __webpack_public_path__ + "static/media/zontech-park.f81ced47.svg";